import OIDCAuthService from 'src/api/oidcAuth';

const state = {
  oidcState: 'login',
  authUrl: OIDCAuthService.generateAuthenticationUrl('login'),
  token: null,
  error: null,
};
const getters = {
  authUrl: (state) => {
    return state.authUrl;
  },
  token: (state) => {
    return state.token;
  },
  error: (state) => {
    return state.error;
  },
};
const actions = {
  async oidcCallback({ commit }, payload) {
    if (payload.error) {
      commit('setError', payload.error);
      throw new Error(payload.error);
    }
    if (!payload.code) {
      commit('setError', 'Code not provided.');
      throw new Error('Code not provided.');
    }
    if (!payload.state) {
      commit('setError', 'State not provided.');
      throw new Error('State not provided.');
    }

    // make call to backend
    const response = await OIDCAuthService.getAuthenticationToken(payload.code);
    if (!response.success) {
      commit('setError', response.message);
      throw new Error(response.message);
    }

    if (response.data.action == 'REGISTER') {
      // redirect to registration
      return "/register/" + response.data.token;
    }

    commit('setToken', response.data);

    return '/search';
  },

  async oidcRegister({ commit }, payload) {
    const response = await OIDCAuthService.register(payload.payload, payload.token);
    if (!response.success) {
      commit('setError', response.message);
      throw new Error(response.message);
    }

    return true;
  },
};
const mutations = {
  setToken(state, payload) {
    sessionStorage.setItem('token', payload.token);
    state.token = payload.token;
  },
  setError(state, payload) {
    state.error = payload;
  },
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
